export function areRangesDifferent(range: [number, number] | null, other: [number, number] | null): boolean {
  return !areRangesEqual(range, other)
}

export function areRangesEqual(range: [number, number] | null, other: [number, number] | null): boolean {
  return range?.[0] === other?.[0] && range?.[1] === other?.[1]
}
